import { CostResponse } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import { TCost } from '~/src/features/tariffBuilder/types/entity';

const prepareCosts = (costResult: Record<number, TCost>, cost: CostResponse): Record<number, TCost> => {
    costResult[cost.duration || 1] = {
        cost: cost.cost,
        period: cost.duration || 1,
    };

    return costResult;
};

export default prepareCosts;
